import { useEffect, useState } from "react";
import { getAdminHeaders } from "./adminApi";

const emptyPlace = {
  name: "",
  province: "",
  city: "",
  district: "",
  address: "",
  phone: "",
  opening_hours: "",
  business_scope: "结婚登记",
  appointment_url: "",
  official_url: "",
  source: "",
  source_name: "",
  category: "official_a",
  can_legal_register: 1,
  note: "",
  status: "active",
  longitude: "",
  latitude: "",
};

export default function AdminMarriagePlaces() {
  const [items, setItems] = useState([]);
  const [policies, setPolicies] = useState([]);
  const [form, setForm] = useState(emptyPlace);
  const [editingId, setEditingId] = useState(null);
  const [policyForm, setPolicyForm] = useState({
    title: "",
    content: "",
    source_name: "",
    official_url: "",
    question_keywords: "",
  });

  const load = async () => {
    const [pRes, polRes] = await Promise.all([
      fetch("/api/admin/marriage/places", { headers: getAdminHeaders() }),
      fetch("/api/admin/marriage/policies", { headers: getAdminHeaders() }),
    ]);
    const pData = await pRes.json();
    const polData = await polRes.json();
    if (pRes.ok) setItems(pData.items || []);
    if (polRes.ok) setPolicies(polData.items || []);
  };

  useEffect(() => {
    load();
  }, []);

  const savePlace = async (e) => {
    e.preventDefault();
    const payload = {
      ...form,
      can_legal_register: Number(form.can_legal_register),
      longitude: form.longitude === "" ? null : Number(form.longitude),
      latitude: form.latitude === "" ? null : Number(form.latitude),
      last_verified_at: new Date().toISOString(),
    };
    const url = editingId ? `/api/admin/marriage/places/${editingId}` : "/api/admin/marriage/places";
    const res = await fetch(url, {
      method: editingId ? "PATCH" : "POST",
      headers: getAdminHeaders(true),
      body: JSON.stringify(payload),
    });
    if (!res.ok) {
      const data = await res.json();
      alert(data.detail || "保存失败");
      return;
    }
    setForm(emptyPlace);
    setEditingId(null);
    load();
  };

  const savePolicy = async (e) => {
    e.preventDefault();
    const res = await fetch("/api/admin/marriage/policies", {
      method: "POST",
      headers: getAdminHeaders(true),
      body: JSON.stringify(policyForm),
    });
    if (!res.ok) return;
    setPolicyForm({ title: "", content: "", source_name: "", official_url: "", question_keywords: "" });
    load();
  };

  return (
    <div className="space-y-8">
      <div>
        <h1 className="text-2xl font-bold">婚姻登记地点管理</h1>
        <p className="text-sm text-gray-500 mt-1">
          正式登记点必须填写官方来源，并在核验后才能把「可办理正式登记」打开。特色点未获机关授权时不得勾选。
        </p>
      </div>
      <form onSubmit={savePlace} className="bg-white rounded-2xl p-5 grid md:grid-cols-2 gap-3">
        {["name", "province", "city", "district", "address", "phone", "opening_hours", "business_scope", "appointment_url", "official_url", "source", "source_name", "note"].map((key) => (
          <input
            key={key}
            value={form[key]}
            onChange={(e) => setForm({ ...form, [key]: e.target.value })}
            placeholder={key}
            className="border rounded-xl px-3 py-2"
            required={key === "name"}
          />
        ))}
        <input value={form.longitude} onChange={(e) => setForm({ ...form, longitude: e.target.value })} placeholder="经度" className="border rounded-xl px-3 py-2" />
        <input value={form.latitude} onChange={(e) => setForm({ ...form, latitude: e.target.value })} placeholder="纬度" className="border rounded-xl px-3 py-2" />
        <select value={form.category} onChange={(e) => setForm({ ...form, category: e.target.value })} className="border rounded-xl px-3 py-2">
          <option value="official_a">A 正式婚姻登记机关</option>
          <option value="special_b">B 政府特色登记点</option>
          <option value="venue_c">C 仪式/婚礼场地</option>
        </select>
        <select value={form.can_legal_register} onChange={(e) => setForm({ ...form, can_legal_register: e.target.value })} className="border rounded-xl px-3 py-2">
          <option value={1}>可办理正式婚姻登记</option>
          <option value={0}>不可办理法律登记</option>
        </select>
        <select value={form.status} onChange={(e) => setForm({ ...form, status: e.target.value })} className="border rounded-xl px-3 py-2">
          <option value="active">已发布</option>
          <option value="pending_verify">待核验</option>
        </select>
        <button className="md:col-span-2 py-3 rounded-xl bg-blue-600 text-white">
          {editingId ? "更新地点并刷新核验时间" : "添加地点"}
        </button>
      </form>
      <div className="overflow-auto bg-white rounded-2xl">
        <table className="min-w-full text-sm">
          <thead>
            <tr className="text-left border-b">
              <th className="p-3">名称</th>
              <th>城市</th>
              <th>类型</th>
              <th>可正式登记</th>
              <th>核验时间</th>
              <th />
            </tr>
          </thead>
          <tbody>
            {items.map((item) => (
              <tr key={item.id} className="border-b">
                <td className="p-3">{item.name}</td>
                <td>{item.city}{item.district}</td>
                <td>{item.category_label}</td>
                <td>{item.can_legal_register ? "是" : "否"}</td>
                <td>{item.last_verified_at || "—"}</td>
                <td>
                  <button
                    className="text-blue-600"
                    onClick={() => {
                      setEditingId(item.id);
                      setForm({
                        ...emptyPlace,
                        ...item,
                        longitude: item.longitude ?? "",
                        latitude: item.latitude ?? "",
                        can_legal_register: item.can_legal_register ? 1 : 0,
                      });
                    }}
                  >
                    编辑
                  </button>
                  <button
                    className="text-red-500 ml-3"
                    onClick={async () => {
                      if (!window.confirm("删除？")) return;
                      await fetch(`/api/admin/marriage/places/${item.id}`, {
                        method: "DELETE",
                        headers: getAdminHeaders(),
                      });
                      load();
                    }}
                  >
                    删除
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <h2 className="text-xl font-bold">政策知识库</h2>
      <form onSubmit={savePolicy} className="bg-white rounded-2xl p-5 space-y-3">
        <input className="border rounded-xl px-3 py-2 w-full" placeholder="标题" value={policyForm.title} onChange={(e) => setPolicyForm({ ...policyForm, title: e.target.value })} />
        <textarea className="border rounded-xl px-3 py-2 w-full" rows={4} placeholder="政策正文（必须可追溯）" value={policyForm.content} onChange={(e) => setPolicyForm({ ...policyForm, content: e.target.value })} />
        <input className="border rounded-xl px-3 py-2 w-full" placeholder="来源名称" value={policyForm.source_name} onChange={(e) => setPolicyForm({ ...policyForm, source_name: e.target.value })} />
        <input className="border rounded-xl px-3 py-2 w-full" placeholder="官方 URL" value={policyForm.official_url} onChange={(e) => setPolicyForm({ ...policyForm, official_url: e.target.value })} />
        <input className="border rounded-xl px-3 py-2 w-full" placeholder="检索关键词" value={policyForm.question_keywords} onChange={(e) => setPolicyForm({ ...policyForm, question_keywords: e.target.value })} />
        <button className="px-5 py-2 rounded-xl bg-blue-600 text-white">新增政策</button>
      </form>
      <ul className="text-sm space-y-2">
        {policies.map((p) => (
          <li key={p.id} className="bg-white rounded-xl p-3">
            <b>{p.title}</b>
            <span className="text-gray-400 ml-2">{p.source_name} · {p.last_verified_at}</span>
          </li>
        ))}
      </ul>
    </div>
  );
}
